import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * When the current record ID changes to a value that is not already in the
 * cache, triggers a getEntity fetch. This handles navigation from pages that
 * don't pre-load the full record (e.g. the Cluster Details assigned-records
 * table), where putInIdLookup is dispatched but the entity isn't yet cached.
 */
export const fetchCurrentEntityOnIdChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asObservable.pipe(
        rxjs.distinctUntilChanged(),
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.withLatestFrom(
          collection.plugins.cachePlugin.feature.selectors.lookup.asObservable,
        ),
        rxjs.filter(([id, lookup]) => !(id in lookup)),
        rxjs.map(() =>
          collection.plugins.currentEntityPlugin.feature.actions.getEntity
            .from('fetchCurrentEntityOnIdChange')
            .create({}),
        ),
      ),
)
